
<template>
  <div>
    <div style="margin-bottom: 32px;">
      <div class="fotterBox-div1">{{ $t("开展展会名称") }}</div>
      <div class="fotterBox-div2">{{ $t('开展时间英文')}}</div>
      <div class="fotterBox-div3">{{ $t('开展地点英文') }}</div>
    </div>
    <div class="footerBox">
      <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/footer_logo.png" />
      <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/footer_logo2.png" />
    </div>
  </div>
</template>
<script>
import face from '@/assets/homeImages/face.png'
import link from '@/assets/homeImages/link.png'
import ins from '@/assets/homeImages/ins.png'
import pin from '@/assets/homeImages/pin.png'
import tw from '@/assets/homeImages/tw.png'
import wechat from '@/assets/homeImages/wechat.png'
import yt from '@/assets/homeImages/yt.png'
import downloadQRcode from '@/assets/homeImages/downloadQRcode.png'
import { mapGetters } from 'vuex'
import footerLogo from '@/assets/images/logo.png'
import footerLogo1 from '@/assets/images/footerLogo1.png'
import footerR from '@/assets/homeImages/footerR.png'

export default {
  props: {
    youMayLike: {
      type: [Object, String, Array],
      default: () => ''
    }
  },
  computed: {
    ...mapGetters(['language']),
  },
  data() {
    return {
      face: face,
      link: link,
      ins: ins,
      pin: pin,
      tw: tw,
      wechat: wechat,
      yt: yt,
      downloadQRcode: downloadQRcode,
      footerLogo:footerLogo,
      footerLogo1: footerLogo1,
      footerR:footerR
    }
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="stylus" scoped>
.m-r-8{
  margin-right 8px
}
.fotterBox-div1{
  font-weight: 600;
  font-size: 24px;
  color: #FFFFFF;
  line-height: 28px;
  margin-bottom:21px;
}
.fotterBox-div2{
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 16px;
  margin-bottom:10px;
}
.fotterBox-div3{
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 20px;
}
</style>
